import { jwtDecode } from 'jwt-decode'

interface JwtPayload {
  exp: number
}

export const getCurrentDate = (): Date => {
  return new Date()
}

export const isTokenValid = (token: string): boolean => {
  try {
    const decodedToken = jwtDecode<JwtPayload>(token)
    const tokenExpiryTime = new Date(decodedToken.exp * 1000)
    const currentDateTime = new Date()
    return tokenExpiryTime >= currentDateTime
  } catch (err) {
    return false
  }
}
